"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[6326],{

/***/ 6326:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productOptions)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function productOptions({ wrapper }) {
  const classes = {
    unavailable: 'tw-oos',
    fullyUnavailable: 'tw-oos-full',
  }

  const selectors = {
    productForm: 'form[action="/cart/add"]',
    radioOptions: 'input[type="radio"][data-hook="product-option"]',
    selectOptions: 'select[data-hook="product-option"]',
    productDataScript: '[type="application/json"][data-hook="product-json"]',
    idInput: 'input[name="id"]',
    optionLabels: '[data-hook="option-label"]',
    isUpsell: '[data-is-upsell-selector]',
    popupMessage: '[data-popup-message]',
    oosTrigger: '[data-toggle="#oos-signup-pop-up"]',
  }

  const cache = {
    $radioOptions: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.radioOptions),
    $selectOptions: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.selectOptions),
    $productDataScript: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.productDataScript),
    $idInput: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).closest(selectors.productForm).find(selectors.idInput),
    $optionLabels: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.optionLabels),
  }

  const $options = cache.$selectOptions.add(cache.$radioOptions)

  const $selectedOptions = () => cache.$radioOptions.filter(':checked').add(cache.$selectOptions.find(':selected'))

  const isUpsell = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is(selectors.isUpsell)

  // Get data for the current product
  const product = getProduct()

  ;(function init() {
    $options.on('change', emitCurrentVariant)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('variant-selector:change', onVariantChange)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('variant-selector:request', emitCurrentVariant)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('upsell-variant-selector:change', onUpsellVariantChange)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('upsell-variant-selector:submit', updateUpsellId)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('upsell-variant-selector:remove', clearUpsellId)

    // Add click handler for OOS popup
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', selectors.oosTrigger, updatePopupMessage)

    // Add keyboard event handling for swatch accessibility
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('keydown', 'label[for*="--"]', handleSwatchKeyboard)
    
    // Add keyboard event handling for radio button labels
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('keydown', 'label[role="radio"]', handleRadioKeyboard)

    // Use requestAnimationFrame to ensure all components are initialized
      emitCurrentVariant()

  })()

  function handleSwatchKeyboard(e) {
    // Handle Enter and Space key presses on swatch labels
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      e.stopPropagation()
      
      const $label = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target)
      const forId = $label.attr('for')
      
      if (forId) {
        const $radio = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`#${forId}`)
        if ($radio.length) {
          $radio.prop('checked', true).trigger('change')
          // Update ARIA attributes immediately
          updateSwatchAriaAttributes()
        }
      }
    }
  }

  function handleRadioKeyboard(e) {
    // Handle Enter and Space key presses on radio button labels
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      e.stopPropagation()
      
      const $label = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target)
      const forId = $label.attr('for')
      
      if (forId) {
        const $radio = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`#${forId}`)
        if ($radio.length) {
          $radio.prop('checked', true).trigger('change')
          // Update ARIA attributes for radio buttons
          updateSwatchAriaAttributes()
        }
      }
    }
  }

  function updatePopupMessage(e) {
    const $trigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).closest(selectors.oosTrigger)
    const isInProduction = $trigger.data('is-in-production') === true
    const $messageElement = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.popupMessage)
    
    if ($messageElement.length) {
      $messageElement.text(
        isInProduction 
          ? "Join the Waitlist!"
          : "We'll let you know when it's back in stock!"
      )
    }
  }

  function emitCurrentVariant() {
    // Get the selected product options' values
    const selectedValues = getSelectedValues()

    // Find product variant that matches the selected product options
    let variant = null
    if (selectedValues.length) {
      variant = getVariant(selectedValues)
    } else {
      // If no options are selected, select the first variant and update DOM
      variant = product.variants[0]
      selectFirstVariantOptions(variant)
    }

    // Emit a custom event w/ the current product & variant as data
    if (isUpsell) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('upsell-variant-selector:change', { variant, product })
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('variant-selector:change', { variant, product, isUpsell })
    }
  }

  function selectFirstVariantOptions(variant) {
    if (!variant || !variant.options) return
    
    // For each option in the first variant, select the corresponding DOM element
    variant.options.forEach((optionValue, index) => {
      const optionName = product.options[index]
      
      // Handle radio buttons (including swatches) - use data-name for swatches
      const $radioOption = cache.$radioOptions.filter(`[data-name="${optionName}"][value="${optionValue}"]`)
      if ($radioOption.length) {
        $radioOption.prop('checked', true)
      }
      
      // Handle select dropdowns
      const $selectOption = cache.$selectOptions.filter(`[data-name="${optionName}"]`)
      if ($selectOption.length) {
        $selectOption.val(optionValue)
      }
    })
  }

  function onVariantChange(event, { variant, isUpsell }) {
    console.log('Variant changed:', { variant, isUpsell })
    
    if (variant) {
      updateMasterId(variant.id)
    }

    const selectedOptions = getSelectedOptions()

    updateOptionLabels(selectedOptions)
    updateOptionUI(variant)
    updateSwatches()
    updateSwatchAriaAttributes()
  }

  /* DOM Manipulators */
  function updateMasterId(id) {
    cache.$idInput.val(id).trigger('change')
  }

  function updateOptionLabels(selectedOptions) {
    function splitColorMaterial(str) {
      const words = str.trim().split(' ')
      const numberIdx = words.findIndex(w => /\d/.test(w))
      if (numberIdx !== -1) {
        return {
          color: words.slice(0, numberIdx).join(' '),
          material: words.slice(numberIdx).join(' ')
        }
      } else if (words.length > 1) {
        return {
          color: words.slice(0, -1).join(' '),
          material: words.slice(-1).join(' ')
        }
      } else {
        return {
          color: str.trim(),
          material: ''
        }
      }
    }

    selectedOptions.forEach((option) => {

      if (option.name.toLowerCase() === 'color' || option.name.toLowerCase() === 'colour') {
        const swatchParts = option.value.split('/')
        const exterior = (swatchParts[0] || '').trim()
        const interior = (swatchParts[1] || '').trim()
        const exteriorParts = splitColorMaterial(exterior)
        const interiorParts = splitColorMaterial(interior)
        
        // Update specific values using data attributes - search directly in wrapper
        const $exteriorColor = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-exterior-color]')
        const $exteriorMaterial = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-exterior-material]')
        const $interiorColor = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-interior-color]')
        const $interiorMaterial = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-interior-material]')
        
        $exteriorColor.text(exteriorParts.color)
        $exteriorMaterial.text(exteriorParts.material)
        $interiorColor.text(interior ? interiorParts.color : '')
        $interiorMaterial.text(interior ? interiorParts.material : '')

        // Hide or show interior columns
        if (interior) {
          $interiorColor.closest('div').show();
          $interiorMaterial.closest('div').show();
        } else {
          $interiorColor.closest('div').hide();
          $interiorMaterial.closest('div').hide();
        }
      } else {
        const $label = cache.$optionLabels.filter(`[data-option="${option.name}"]`)
        $label.text(option.value)
      }
    })
  }

  function updateOptionUI(variant) {
    const allOptionCombinations = getAllOptionCombinations()
    disableUnavailableOptions(allOptionCombinations)

    if (!variant || !variant.available) {
      $selectedOptions().addClass(classes.unavailable)
    }
  }

  function disableUnavailableOptions(optionCombos) {
    $options.removeClass(classes.unavailable)

    optionCombos.forEach((combo) => {
      const variant = getVariant(Object.values(combo))

      if (!variant || !variant.available) {
        const optionVal = CSS.escape(combo.dynamicOption)
        const $dynamicOption = $options.filter(`[value="${optionVal}"]`)

        $dynamicOption.addClass(classes.unavailable)
      }
    })
  }

  function updateSwatches() {
    const $swatches = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('input[data-name="Color"]')

    $swatches.each(function (index, swatch) {
      let isAvailable = false
      product.variants.forEach((variant) => {
        variant.options.forEach((option) => {
          if (option == swatch.value && variant.available) isAvailable = true
        })
      })

      if (isAvailable) return

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swatch).addClass(classes.fullyUnavailable)
    })
  }

  function updateSwatchAriaAttributes() {
    // Update ARIA attributes for all radio inputs
    const $radioInputs = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('input[type="radio"]')
    
    $radioInputs.each(function() {
      const $radio = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
      const isChecked = $radio.is(':checked')
      $radio.attr('aria-checked', isChecked.toString())
    })
  }

  /* Utilities */

  function getProduct() {
    return JSON.parse(cache.$productDataScript.text())
  }

  function getVariant(selectedValues) {
    const found = product.variants.find(function (variant) {
      if (variant.options.sort().join(',') === selectedValues.sort().join(',')) {
        return variant
      }
    })
    return found
  }

  function getSelectedOptions() {
    return $selectedOptions()
      .map(function (index, option) {
        return {
          name: jquery__WEBPACK_IMPORTED_MODULE_0___default()(option).data('name'),
          value: jquery__WEBPACK_IMPORTED_MODULE_0___default()(option).val(),
        }
      })
      .get()
  }

  function getSelectedValues() {
    const $selected = $selectedOptions()
    
    const values = $selected
      .map(function (index, element) {
        const value = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).val()
        return value
      })
      .get()
    
    return values
  }

  function getOptionNames() {
    return $selectedOptions()
      .map(function (index, element) {
        return jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).attr('name')
      })
      .get()
  }

  function getUnselectedOptionsFromName(name) {
    const $firstOption = $options.filter(`[name="${name}"]`).eq(0)
    let $unselectedOptions = null

    if ($firstOption.is(selectors.radioOptions)) {
      $unselectedOptions = cache.$radioOptions.filter(`[name="${name}"]:not(:checked)`)
    }

    if ($firstOption.is(selectors.selectOptions)) {
      const $relevantSelect = cache.$selectOptions.filter(`[name="${name}"]`)
      $unselectedOptions = $relevantSelect.children().filter(`:not(:checked)`)
    }

    return $unselectedOptions
  }

  function getAllOptionCombinations() {
    const optionNames = getOptionNames()

    return optionNames.reduce((accumulator, name) => {
      const $unselectedOptions = getUnselectedOptionsFromName(name)
      const $otherSelectedOptions = $selectedOptions().not(`[name="${name}"]`)
      const otherSelectedOptions = $otherSelectedOptions.map((index, option) => jquery__WEBPACK_IMPORTED_MODULE_0___default()(option).val()).get()

      const combinations = $unselectedOptions.map(function (index, option) {
        return {
          dynamicOption: jquery__WEBPACK_IMPORTED_MODULE_0___default()(option).val(),
          ...otherSelectedOptions,
        }
      })

      return [...accumulator, ...combinations]
    }, [])
  }

  // Upsell Logic

  function onUpsellVariantChange(event, { variant }) {
    const selectedOptions = getSelectedOptions()

    updateOptionLabels(selectedOptions)
    updateOptionUI(variant)
  }

  function updateUpsellId(e, { id }) {
    const selectedValues = getSelectedValues()
    const variant = getVariant(selectedValues)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(`input[name="add-on-id"][data-id=${id}]`).val(variant.id)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('upsell-variant-selector:added', { variant, product })
  }

  function clearUpsellId(e, { id }) {
    const $input = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`input[name="add-on-id"][data-id=${id}]`)

    $input.val('')
  }
}


/***/ })

}]);